import { isEmpty as estoolkitIsEmpty } from "es-toolkit/compat";

/**
 *
 * Checks if value is an empty object, collection, map, or set.
 * Objects are considered empty if they have no own enumerable string keyed properties.
 * Array-like values such as arguments objects, arrays, buffers, strings, or jQuery-like collections are considered empty if they have a length of 0. Similarly, maps and sets are considered empty if they have a size of 0.
 *
 * @param value - The value to check.
 * @returns Returns true if the value is empty, else false.
 */
function isEmpty(value: unknown): boolean {
  return estoolkitIsEmpty(value);
}

export { isEmpty };
